import classNames from 'classnames'
import {ComponentProps} from 'react'
import S from './styles.module.scss'

export const Caption = (props: ComponentProps<'div'>) => (
  <div {...props} className={classNames(S.caption, props.className)} />
)
